import {defineStore} from 'pinia'
import api from '@/services/api'

export const useFieldsetsStore = defineStore('fieldsets', {
    state: () => ({
        items: []
    }),
    
    actions: {
        async init() {
            const obj = await api.get('api/component/fieldset', {
                params: {
                    sort: 'displayOrder'
                }
            })
            
            this.items = obj.data.items || []
        }
    }
})